export const customerKey = (apt) =>
  (apt.customer_email || '').trim().toLowerCase() || (apt.customer_name || '').trim().toLowerCase() || apt.id;

export const countUniqueCustomers = (appointments) => new Set(appointments.map(customerKey)).size;

const isRealJob = (apt) => apt.status !== 'customer_only' && apt.status !== 'cancelled';

const startOfDay = (d) => { const x = new Date(d); x.setHours(0, 0, 0, 0); return x; };

export const getTodaysJobs = (appointments) => {
  const today = startOfDay(new Date()).getTime();
  return appointments
    .filter((a) => isRealJob(a) && startOfDay(a.start_time).getTime() === today)
    .sort((a, b) => new Date(a.start_time) - new Date(b.start_time));
};

const toNumber = (p) => parseFloat(String(p ?? '').replace(/[^0-9.]/g, '')) || 0;

const FREQ_PER_MONTH = { Weekly: 4.33, 'Bi-Weekly': 2.17, Monthly: 1 };

export const getEarnings = (appointments) => {
  const now = new Date();
  const weekStart = startOfDay(now);
  weekStart.setDate(weekStart.getDate() - weekStart.getDay());
  const weekEnd = new Date(weekStart);
  weekEnd.setDate(weekEnd.getDate() + 7);
  const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
  const monthEnd = new Date(now.getFullYear(), now.getMonth() + 1, 1);

  let week = 0;
  let month = 0;
  appointments.filter(isRealJob).forEach((a) => {
    const d = new Date(a.start_time);
    const price = toNumber(a.price);
    if (d >= weekStart && d < weekEnd) week += price;
    if (d >= monthStart && d < monthEnd) month += price;
  });

  const recurring = new Map();
  appointments.forEach((a) => {
    if (a.is_recurring && a.recurring_active !== false && a.recurrence_frequency) {
      recurring.set(customerKey(a), a);
    }
  });
  const recurringMonthly = Array.from(recurring.values())
    .reduce((sum, a) => sum + toNumber(a.price) * (FREQ_PER_MONTH[a.recurrence_frequency] || 1), 0);

  return { week, month, recurringMonthly, recurringCount: recurring.size };
};

export const money = (n) => `$${Math.round(n).toLocaleString()}`;
